import Link from 'next/link';
import { Logo, Sidebar as UiSidebar } from 'ui';

interface Props {
  isSidebarOpen: boolean;
}

const DesktopHeader = ({ isSidebarOpen }: Props) => {
  return (
    <UiSidebar.Logo component={Link} href="/">
      <Logo source={isSidebarOpen ? '/images/logo.svg' : '/images/logo-circle.png'} size="big" />
    </UiSidebar.Logo>
  );
};

export { DesktopHeader };
